import MuterPopup from './MuterPopup'

export default {
  install(Vue) {
    Vue.component('muter-popup', MuterPopup)
  },
}
